// Facebook Pixel tracking utility
// Pixel ID: 164411937448905

/**
 * Track a Facebook Pixel event
 * @param {string} eventName - Standard or custom event name
 * @param {object} params - Optional parameters for the event
 */
export const trackFBEvent = (eventName, params = {}) => {
  if (typeof window !== 'undefined' && window.fbq) {
    window.fbq('track', eventName, params);
    console.log(`[FB Pixel] Tracked: ${eventName}`, params);
  }
};

/**
 * Track a custom Facebook Pixel event
 * @param {string} eventName - Custom event name
 * @param {object} params - Optional parameters for the event
 */
export const trackFBCustomEvent = (eventName, params = {}) => {
  if (typeof window !== 'undefined' && window.fbq) {
    window.fbq('trackCustom', eventName, params);
    console.log(`[FB Pixel] Custom event: ${eventName}`, params);
  }
};

// Standard Facebook Pixel Events for CompareYourOptions funnel:

/**
 * Track PageView - Called when user lands on a page
 */
export const trackPageView = () => {
  trackFBEvent('PageView');
};

/**
 * Track ViewContent - When user views comparison options
 * @param {string} contentName - Product type (solar, battery, etc.)
 * @param {string} contentCategory - Category name
 */
export const trackViewContent = (contentName, contentCategory = 'Comparison') => {
  trackFBEvent('ViewContent', {
    content_name: contentName,
    content_category: contentCategory,
  });
};

/**
 * Track Lead - When user submits initial enquiry
 * @param {string} productType - Product type
 * @param {string} postcode - User's postcode
 */
export const trackLead = (productType, postcode) => {
  trackFBEvent('Lead', {
    content_name: productType,
    content_category: 'Enquiry',
    postcode: postcode,
  });
};

/**
 * Track CompleteRegistration - When user completes mobile verification
 * @param {string} productType - Product type
 */
export const trackCompleteRegistration = (productType) => {
  trackFBEvent('CompleteRegistration', {
    content_name: productType,
    status: 'verified',
  });
};

/**
 * Track InitiateCheckout - When user clicks "See My Pricing"
 * @param {string} productType - Product type
 * @param {string} optionTier - Selected tier (good, best, max)
 */
export const trackInitiateCheckout = (productType, optionTier) => {
  trackFBEvent('InitiateCheckout', {
    content_name: productType,
    content_category: optionTier,
  });
};

/**
 * Track Contact - When user submits full contact details
 * @param {string} productType - Product type
 */
export const trackContact = (productType) => {
  trackFBEvent('Contact', {
    content_name: productType,
  });
};

// Custom events for deeper funnel tracking

/**
 * Track product selection on homepage
 * @param {string} productType - Product type selected
 */
export const trackProductSelected = (productType) => {
  trackFBCustomEvent('ProductSelected', {
    product_type: productType,
  });
};

/**
 * Track address entry
 * @param {string} productType - Product type
 * @param {string} postcode - Extracted postcode
 */
export const trackAddressEntered = (productType, postcode) => {
  trackFBCustomEvent('AddressEntered', {
    product_type: productType,
    postcode: postcode,
  });
};

/**
 * Track when user views pricing (after mobile verification)
 * @param {string} productType - Product type
 * @param {number} price - Price shown
 */
export const trackPricingViewed = (productType, price) => {
  trackFBCustomEvent('PricingViewed', {
    product_type: productType,
    value: price,
    currency: 'AUD',
  });
};
